import { ProductRoutesEnum } from '@utilities/enums';
import { fetchRequest } from "@utilities/requests";
import { 
    AddProductFormType, AddSupplyInputType, 
    FetchResponseType, UpdateProductFormType,
} from "@utilities/types";

export const ProductService = {
    addProduct:
        async (product: AddProductFormType, images: File[]): Promise<FetchResponseType> => {
            try {
                // Utilisation de FormData pour multipart/form-data
                const formData = new FormData();

                // Ajout des champs basiques
                formData.append('name', product.name);
                formData.append('organisationID', product.organisationID!);
                formData.append('categoryID', product.categoryID);
                formData.append('description', product.description);
                formData.append('price', product.price.toString());
                if (product.purchasePrice !== undefined) {
                    formData.append('purchasePrice', product.purchasePrice.toString());
                }
                formData.append('variationType', product.variationType);
                formData.append('variations', JSON.stringify(product.variations));
                formData.append('isRemovedBackground', product.isRemovedBackground ? 'true' : 'false');

                images.forEach(image => {
                    formData.append('images', image);
                });

                const response = await fetchRequest({
                    route: ProductRoutesEnum.PRODUCT_CREATE,
                    method: 'POST',
                    data: formData,
                    isFormData: true
                });

                return response;

            } catch (error: any) {
                console.error('Error in createProduct:', error);
                throw error;
            }
        },

    getAllOrganisationProducts:
        async (organisationId: string, page: number, limit: number, isProductManagement?: boolean): Promise<FetchResponseType> => {
            try {
                const response = await fetchRequest({
                    route: `${ProductRoutesEnum.PRODUCT_GET_ALL_ORGANISATION_PRODUCTS}/${organisationId}?page=${page}&limit=${limit}&isProductManagement=${isProductManagement}`,
                    method: 'GET'
                });

                return response;

            } catch (error: any) {
                console.error('Error in getAllOrganisationProducts:', error);
                throw error;
            }
        },

    getAllProductsByCategory:
        async (categoryId: string, page: number, limit: number, isProductManagement?: boolean): Promise<FetchResponseType> => {
            try {
                const response = await fetchRequest({
                    route: `${ProductRoutesEnum.PRODUCT_GET_ALL_BY_CATEGORY}/${categoryId}?page=${page}&limit=${limit}&isProductManagement=${isProductManagement}`,
                    method: 'GET'
                });

                return response;

            } catch (error: any) {
                console.error('Error in getAllProductsByCategory:', error);
                throw error;
            }
        },

    updateProduct:
        async (productId: string, productData: UpdateProductFormType): Promise<FetchResponseType> => {
            const response = await fetchRequest({
                route: `${ProductRoutesEnum.PRODUCT_UPDATE}/${productId}`,
                method: 'PUT',
                data: productData
            });

            return response;
        },

    supplyProduct: 
        async ( productId: string, supplyData: AddSupplyInputType ): Promise<FetchResponseType> => {
            const response = await fetchRequest({
                route: `${ProductRoutesEnum.PRODUCT_SUPPLY}/${productId}`,
                method: 'PUT',
                data: supplyData
            });
    
            return response;
        },

    deleteProduct: 
        async ( productId: string ): Promise<FetchResponseType> => {
            const response = await fetchRequest({
                route: `${ProductRoutesEnum.PRODUCT_DELETE}/${productId}`,
                method: 'DELETE'
            });

            return response;
        },

    searchProducts:
        async (organisationId: string, searchTerm: string, page = 1, limit = 20): Promise<FetchResponseType> => {
            try {
                const response = await fetchRequest({
                    route: `${ProductRoutesEnum.PRODUCT_SEARCH}/${organisationId}?q=${encodeURIComponent(searchTerm)}&page=${page}&limit=${limit}`,
                    method: 'GET'
                });

                return response;

            } catch (error: any) {
                console.error('Error in searchProducts:', error);
                throw error;
            }
        },
}
